
import { apiClient } from "../../Utils/apiClient";

class SettingsClass {
  async toggleAutoMailFeature(
    accessToken: string,
    sessionToken: string,
    custId: any
  ): Promise<any> {
    return apiClient.patch(`update-user-auto-mail/${custId}`, accessToken, sessionToken);
  }
}

const SettingsFunction = new SettingsClass();

export default SettingsFunction;
